module.exports = __webpack_public_path__ + "assets/retina_SquareByOppMidpointsDetailed.c0ae9bc8bf97b3701246ee5495f91b99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_SquareByOppMidpointsDetailed.png
// module id = 720
// module chunks = 0